import { AxiosError } from "axios";
import type { Debug } from "debug";
import debug from "debug";
import * as Sentry from "@sentry/browser";

/**
 * The Console API automatically sends console.debug, console.error,
 * console.info, console.log, console.trace and console.warn calls to
 * the native log system on each respective platform.
 *
 * @see https://capacitorjs.com/docs/v2/apis/console
 */

interface LogFn {
  (topic?: string): (...args: any[]) => Debug | void;
}

let logFn: LogFn = () => () => {};

debug.log = (...args: any[]) => {
  const hasError = args.some(
    (arg) =>
      arg instanceof Error ||
      arg instanceof AxiosError ||
      (typeof arg === "string" && arg.includes("%cError: ")),
  );

  if (hasError) {
    const exception = args.find(
      (arg) => arg instanceof Error || arg instanceof AxiosError,
    );

    console.error.call(console, ...args);
    Sentry.captureException(exception);
  } else {
    console.info.call(console, ...args);
  }
};

debug.enable("app:*");
logFn = (topic = "app") => debug(topic);

export const getLogger = logFn;
